import { call, put, takeEvery } from "redux-saga/effects";
import {
    getDashboardPlanFail,
    getDashboardPlanSuccess,
    getAllDashboardPlanSuccess,
    getAllDashboarPlanFail,
    getUnitFail,
    getUnitSuccess,
    getHistoryFail,
    getHistorySuccess,
    getTeamFail,
    getTeamSuccess,
} from "./slice";
import {
    getDashboardPlan,
    getUnit,
    getHistory,
    getTeam,
} from "../../api/backend_helper";

function* getDashboardPlanSaga(action) {
    try {
        const {
            page,
            limit,
            timeStartReq,
            timeEndReq,
            filterBuildings,
            orderCode,
            category,
            factoryCode,
            status,
            filterStatus,
            filterUnit,
            filterTeamWorking,
            priority,
        } = action.payload;
        const data = yield call(getDashboardPlan, {
            page,
            limit,
            timeStartReq,
            timeEndReq,
            filterBuildings,
            orderCode,
            category,
            factoryCode,
            status,
            filterStatus,
            filterUnit,
            filterTeamWorking,
            priority,
        });
        yield put(getDashboardPlanSuccess(data));
    } catch (error) {
        yield put(getDashboardPlanFail(error.message));
    }
}

function* getAllDashboardPlanSaga(action) {
    try {
        const {
            page,
            limit,
            timeStartReq,
            timeEndReq,
            filterBuildings,
            orderCode,
            category,
            factoryCode,
            current,
            filterStatus,
            filterUnit,
            filterTeamWorking,
            priority,
        } = action.payload;

        const data = yield call(getDashboardPlan, {
            page,
            limit,
            timeStartReq,
            timeEndReq,
            filterBuildings,
            orderCode,
            category,
            factoryCode,
            current,
            filterStatus,
            filterUnit,
            filterTeamWorking,
            priority,
        });

        yield put(getAllDashboardPlanSuccess(data));
    } catch (error) {
        yield put(getAllDashboarPlanFail(error.message));
    }
}

function* getUnitSaga() {
    try {
        const data = yield call(getUnit);
        yield put(getUnitSuccess(data));
    } catch (error) {
        yield put(getUnitFail(error.message));
    }
}

function* getHistorySaga(action) {
    try {
        const data = yield call(getHistory, action.payload);

        yield put(getHistorySuccess(data));
    } catch (error) {
        yield put(getHistoryFail(error.message));
    }
}

function* getTeamSaga() {
    try {
        const data = yield call(getTeam);
        yield put(getTeamSuccess(data));
    } catch (error) {
        yield put(getTeamFail(error.message));
    }
}

function* DashboardPlan() {
    yield takeEvery("dashboardPlan/getDashboardPlan", getDashboardPlanSaga);
    yield takeEvery(
        "dashboardPlan/getAllDashboardPlan",
        getAllDashboardPlanSaga
    );
    yield takeEvery("dashboardPlan/getUnit", getUnitSaga);
    yield takeEvery("dashboardPlan/getHistory", getHistorySaga);
    yield takeEvery("dashboardPlan/getTeam", getTeamSaga);
}

export default DashboardPlan;
